import { render, staticRenderFns } from "./DocumentDetailPDFViewerDialog.vue?vue&type=template&id=c4a2af5a&"
import script from "./DocumentDetailPDFViewerDialog.vue?vue&type=script&lang=ts&"
export * from "./DocumentDetailPDFViewerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports